import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import * as FlatServices from '@medsurf/flat-services';
import { DialogService } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { MediaLibraryComponent } from "../../common/media-library/media-library.component";

@Component({
    selector: 'medsurf-slide-main',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './slide-main.component.html',
    styleUrls: ['./slide-main.component.scss'],
    standalone: false
})
export class SlideMainComponent {
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public menuSharedFacade: FlatFacades.MenuSharedFacade,
              public mediaControlService: FlatServices.MediaControlService,
              public dialogService: DialogService,
              public translate: TranslateService,) {
  }
  
  chooseMedia() {
    // Open Dialog
    const dialogRef = this.dialogService.open(MediaLibraryComponent, {
      header: this.translate.instant("global.image_choose"),
      data: {
        isModal: true,
        multiple: false,
        allowedTypes: [
          FlatModels.MediaEntityModels.MediaType.enum.MediaImage, 
          FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom,
          FlatModels.MediaEntityModels.MediaType.enum.MediaVideo,
          FlatModels.MediaEntityModels.MediaType.enum.MediaAudio
        ]
      } satisfies FlatModels.ModalAuthorModels.MediaLibraryModalData,
      dismissableMask: true,
      width: '90%',
      height: '90%',
      maximizable: true,
      rtl: true,
    });
    dialogRef.onClose.subscribe(media => {
      if (media) {
        // Get Data
        const page = structuredClone(this.slideAuthorFacade.snapshot_page()) as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training;
        
        // Request Add Layer And Image And Thumbnail
        this.slideAuthorFacade.requestAddLayerAndImageAndThumbnail(page, media.id).subscribe({
          error: (result) => this.alertControlFacade.requestAddError(result),
        });
      }
    });
  }

  wysiwygOnResizeStart() {
    this.slideAuthorFacade.requestSetIsSplitterMoving(true).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
  }

  wysiwygOnResizeEnd(event: { sizes: number[] }) {
    this.slideAuthorFacade.requestSetIsSplitterMoving(false).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
    this.slideAuthorFacade.requestSetWysiwygPanelSize(event.sizes).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
  }
}
